import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";
import ContractModel from "../models/ContractModel";

const ContractInfoContext = createContext();

export default function ContractInfoProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();

  const [contractInfo, setContractInfo] = useState([]);

  const getContractInfo = async (siteId) => {
    try {
      const retrievedContractInfoObject = {};

      const data = await Promise.all([
        auth.get(`contract/api/equipmentCovered/${siteId}`),
        auth.get(`contract/api/outOfHours/${siteId}`),
        auth.get(`contract/api/responsepurchase/${siteId}`),
        auth.get(`contract/api/whocancall/${siteId}`),
      ]);

      data.flat().forEach((contract) => {
        const existing = retrievedContractInfoObject[contract.contractID];
        if (existing) {
          existing.mergeContract(contract);
        } else {
          retrievedContractInfoObject[contract.contractID] = new ContractModel(
            contract
          );
        }
      });

      const retrievedContractInfo = Object.values(retrievedContractInfoObject);

      logger.debug(
        "ContractInfoProvider.getContractInfo",
        `Retrieved data for site '${siteId}'`
      );

      const filteredContractInfo = retrievedContractInfo.filter(
        (contract) =>
          contract.isConfigured && contract.allowedCallers.length > 0
      );

      setContractInfo(filteredContractInfo);
      return filteredContractInfo;
    } catch (error) {
      logger.debug(
        "ContractInfoProvider.getProperty",
        `Failed to retrieve data for property '${siteId}', Error: ${JSON.stringify(
          error
        )}`
      );
      return null;
    }
  };

  const getPurchaseOrder = () => {
    if (contractInfo.length === 1) {
      return contractInfo[0].purchaseOrder || "";
    }
    return "";
  };

  return (
    <ContractInfoContext.Provider
      value={{
        getContractInfo,
        getPurchaseOrder,
      }}
    >
      {children}
    </ContractInfoContext.Provider>
  );
}

ContractInfoProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useContractInfo = () => useContext(ContractInfoContext);
